import { render } from "./Welcome.vue?vue&type=template&id=546c1e27"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=546c1e27&lang=css"

import exportComponent from "/Users/kate/Documents/Home/live-chat/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__